import css from 'styled-jsx/css';

export default css`
@-webkit-keyframes kf_el_byGxbhfQi7_an_EkCnlDpna{
  33.33%{
      -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) rotate(2deg) translate(-50.49974536895752px, -49.49968338012695px);
      transform: translate(50.49974536895752px, 49.49968338012695px) rotate(2deg) translate(-50.49974536895752px, -49.49968338012695px);
 }
  50%{
      -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) rotate(-2deg) translate(-50.49974536895752px, -49.49968338012695px);
      transform: translate(50.49974536895752px, 49.49968338012695px) rotate(-2deg) translate(-50.49974536895752px, -49.49968338012695px);
 }
  72.22%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) rotate(3deg) translate(-50.49974536895752px, -49.49968338012695px);
      transform: translate(50.49974536895752px, 49.49968338012695px) rotate(3deg) translate(-50.49974536895752px, -49.49968338012695px);
 }
  0%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) rotate(2deg) translate(-50.49974536895752px, -49.49968338012695px);
      transform: translate(50.49974536895752px, 49.49968338012695px) rotate(2deg) translate(-50.49974536895752px, -49.49968338012695px);
 }
  100%{
      -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) rotate(3deg) translate(-50.49974536895752px, -49.49968338012695px);
      transform: translate(50.49974536895752px, 49.49968338012695px) rotate(3deg) translate(-50.49974536895752px, -49.49968338012695px);
 }
}
@keyframes kf_el_byGxbhfQi7_an_EkCnlDpna{
  33.33%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) rotate(2deg) translate(-50.49974536895752px, -49.49968338012695px);
     transform: translate(50.49974536895752px, 49.49968338012695px) rotate(2deg) translate(-50.49974536895752px, -49.49968338012695px);
 }
 50%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) rotate(-2deg) translate(-50.49974536895752px, -49.49968338012695px);
     transform: translate(50.49974536895752px, 49.49968338012695px) rotate(-2deg) translate(-50.49974536895752px, -49.49968338012695px);
 }
 72.22%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) rotate(3deg) translate(-50.49974536895752px, -49.49968338012695px);
     transform: translate(50.49974536895752px, 49.49968338012695px) rotate(3deg) translate(-50.49974536895752px, -49.49968338012695px);
 }
 0%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) rotate(2deg) translate(-50.49974536895752px, -49.49968338012695px);
     transform: translate(50.49974536895752px, 49.49968338012695px) rotate(2deg) translate(-50.49974536895752px, -49.49968338012695px);
 }
 100%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) rotate(3deg) translate(-50.49974536895752px, -49.49968338012695px);
     transform: translate(50.49974536895752px, 49.49968338012695px) rotate(3deg) translate(-50.49974536895752px, -49.49968338012695px);
 }
}
@-webkit-keyframes kf_el_byGxbhfQi7_an_M_WNks9jO{
 0%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
     transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
 }
 27.78%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(-5px, -5px);
     transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(-5px, -5px);
 }
 66.67%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(2px, 3px);
     transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(2px, 3px);
 }
 94.44%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
     transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
 }
 100%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
     transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
 }
}
@keyframes kf_el_byGxbhfQi7_an_M_WNks9jO{
 0%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
     transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
 }
 27.78%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(-5px, -5px);
     transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(-5px, -5px);
 }
 66.67%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(2px, 3px);
     transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(2px, 3px);
 }
 94.44%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
     transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
 }
 100%{
     -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
     transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
 }
}
#el_xo_0d2lxn *{
 -webkit-animation-duration: 3s;
 animation-duration: 3s;
 -webkit-animation-iteration-count: infinite;
 animation-iteration-count: infinite;
 -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
 animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_ClGD-JVj2u{
 stroke: none;
 stroke-width: 1;
 fill: none;
}
#el_RnOsthswUz{
 -webkit-transform: translate(-309px, -252px);
 transform: translate(-309px, -252px);
}
#el_XYFcVsiNJc{
 -webkit-transform: translate(309px, 252px);
 transform: translate(309px, 252px);
}
#el_9mOKN6YRsg{
 fill: #00A9E0;
}
#el_n547hYU9zj{
 fill: #5BC500;
}
#el_EzC8jWgua1{
 -webkit-transform: translate(9px, 2px);
 transform: translate(9px, 2px);
}
#el_g_HNDgW2oI{
 fill-opacity: 0.4;
 fill: #FFFFFF;
}
#el_MRVuw4zPJ-{
 fill: #ECD7C0;
}
#el_mbgtISk4Mu{
 stroke-width: 1;
 fill: none;
 -webkit-transform: translate(0px, 21px);
 transform: translate(0px, 21px);
}
#el_rtPjm6EKet{
 fill: #ECD7C0;
}
#el_vGiUZYq_ty{
 fill: #ECD7C0;
}
#el_2H11luATUd{
 fill: #ECD7C0;
}
#el_piciIa1Ynq{
 fill: #ECD7C0;
}
#el_h_FHdXI4mj{
 fill: #EC6839;
}
#el_rKb2IXPhMnJ{
 fill: #FFFFFF;
}
#el_QOtDhzhGkhk{
 fill: #FFFFFF;
}
#el_UCp0O8lcIZ8{
 fill: #ECD7C0;
}
#el_z2eeFH9sD69{
 fill: #ECD7C0;
}
#el_RrDyTYDi-qb{
 fill: #ECD7C0;
}
#el_5zmySav7isJ{
 fill: #D3B590;
}
#el_jvwQp1O1BUD{
 fill: #D3B590;
}
#el_w43aql_gORc{
 fill: #D3B590;
}
#el_wGhzWTynHaA{
 -webkit-transform: translate(0px, 58.745763px);
 transform: translate(0px, 58.745763px);
}
#el_mIqL1Xwl_s8{
 fill: #FFFFFF;
}
#el_byGxbhfQi7_an_M_WNks9jO{
 -webkit-animation-fill-mode: backwards;
 animation-fill-mode: backwards;
 -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
 transform: translate(50.49974536895752px, 49.49968338012695px) translate(-50.49974536895752px, -49.49968338012695px) translate(0px, 0px);
 -webkit-animation-name: kf_el_byGxbhfQi7_an_M_WNks9jO;
 animation-name: kf_el_byGxbhfQi7_an_M_WNks9jO;
 -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
 animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_byGxbhfQi7_an_EkCnlDpna{
 -webkit-animation-fill-mode: backwards;
 animation-fill-mode: backwards;
 -webkit-transform: translate(50.49974536895752px, 49.49968338012695px) rotate(2deg) translate(-50.49974536895752px, -49.49968338012695px);
 transform: translate(50.49974536895752px, 49.49968338012695px) rotate(2deg) translate(-50.49974536895752px, -49.49968338012695px);
 -webkit-animation-name: kf_el_byGxbhfQi7_an_EkCnlDpna;
 animation-name: kf_el_byGxbhfQi7_an_EkCnlDpna;
 -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
 animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
`;